class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.autoCloseTimer = null;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    window.clearTimeout(this.autoCloseTimer);
    this.notification.classList.add('animate', 'active');
    document.body.addEventListener('click', this.onBodyClick);
    this.autoCloseTimer = window.setTimeout(() => this.close(), 3200);
  }

  close() {
    window.clearTimeout(this.autoCloseTimer);
    this.autoCloseTimer = null;
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    // The cart can contain both shipping arrangements. Describe only the
    // variant that was just added; never imply that the whole cart is Delivered.
    this.updateShippingNotice(parsedState);
    if (this.header) this.header.reveal();
    this.open();
  }

  updateShippingNotice(item) {
    const wrapper = this.querySelector('[data-sd-notification-shipping]');
    const pill = this.querySelector('[data-sd-notification-shipping-pill]');
    if (!wrapper || !pill) return;

    const options = [];
    if (Array.isArray(item?.options_with_values)) {
      item.options_with_values.forEach((entry) => options.push(entry?.value));
    }
    if (Array.isArray(item?.variant_options)) options.push(...item.variant_options);
    if (typeof item?.variant_title === 'string') {
      options.push(...item.variant_title.split('/'));
    }

    const own = item?.properties?._shipping_arrangement === 'arrange_own_freight' ||
      options.some((value) => String(value || '').trim() === 'Arrange Your Own Freight');
    const delivered = !own && options.some((value) => String(value || '').trim() === 'SeoulDepot Delivered');

    // Older products without the freight option get a neutral confirmation.
    wrapper.hidden = !own && !delivered;
    pill.textContent = own ? 'Arrange Your Own Freight' : delivered ? 'SeoulDepot Delivered' : '';
    pill.dataset.freight = own ? 'own' : delivered ? 'delivered' : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
